import { storage } from '@treatwell/ui';
import { LocationPoint } from 'js/model/rainbow/LocationPoint';
import { MenuGroup, VenueLocation } from 'js/model/rainbow/venue/VenueOutput';
import { SelectedServices } from 'js/pages/VenuePage/VisitConfiguratorBar/VisitConfiguratorBar';

type CheckoutEventIds = {
  treatmentTypeId?: number;
  serviceId?: string;
  treatmentCategoryIds?: number[];
  selectedOptionIds?: string[];
};

const removeServiceSuffix = (serviceId: string) => {
  return serviceId.replace(/TP|TR/, '');
};

const key = (venueId: string) =>
  `venue-basket-treatmentCategoryIds-location-${venueId}`;

function persist({
  venueId,
  treatmentCategoryIds,
  checkoutEventIds,
  locationPoint,
}: {
  venueId: number;
  treatmentCategoryIds: Set<number>;
  locationPoint: LocationPoint;
  checkoutEventIds: Record<string, CheckoutEventIds>;
}) {
  storage.local.setItem(key(String(venueId)), {
    treatmentCategoryIds: Array.from(treatmentCategoryIds),
    checkoutEventIds,
    locationPoint,
  });
}

const getTreatmentIds = (
  menuGroups: MenuGroup[],
  groupId: string,
  prefixedServiceId: string
) => {
  const group = menuGroups.find((g) => String(g.id) === groupId);

  const menuItem = group?.menuItems.find(
    (item) => item.data.id === prefixedServiceId
  );

  return {
    treatmentCategoryIds: menuItem?.data.treatmentCategoryIds,
    treatmentType: menuItem?.data.primaryTreatmentCategoryGroupId,
  };
};

export const persistVenueBasketAvailableSalons = ({
  venueId,
  menuGroups,
  selectedGroups,
  location,
}: {
  venueId: number;
  menuGroups: MenuGroup[];
  selectedGroups: SelectedServices;
  location: VenueLocation;
}) => {
  const treatmentCategoryIdsList = new Set<number>();
  const checkoutEventIdsList: Record<string, CheckoutEventIds> = {};

  Object.keys(selectedGroups).forEach((groupId) => {
    const group = selectedGroups[groupId];

    Object.keys(group).forEach((prefixedServiceId) => {
      const { treatmentCategoryIds, treatmentType } = getTreatmentIds(
        menuGroups,
        groupId,
        prefixedServiceId
      );

      const serviceId = removeServiceSuffix(prefixedServiceId);
      const checkoutEventIds = {
        treatmentTypeId: treatmentType || undefined,
        serviceId: prefixedServiceId,
        treatmentCategoryIds: treatmentCategoryIds
          ? Array.from(new Set<number>(treatmentCategoryIds))
          : undefined,
        selectedOptionIds: Object.keys(group[prefixedServiceId]),
      };

      if (treatmentCategoryIds) {
        treatmentCategoryIds.forEach((id) => treatmentCategoryIdsList.add(id));
      }

      if (checkoutEventIds) {
        checkoutEventIdsList[serviceId] = checkoutEventIds;
      }
    });
  });

  persist({
    venueId,
    treatmentCategoryIds: treatmentCategoryIdsList,
    checkoutEventIds: checkoutEventIdsList,
    locationPoint: location.point,
  });
};
